<div class="edit-container">
    <h1 class="edit-title">Editează</h1>
    <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="form-field">
            <mat-form-field class="w-100" appearance="fill">
                <mat-label>Nume Tip Taxă</mat-label>
                <input type="text" matInput formControlName="numeTipTaxa" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['numeTipTaxa'].valid && form.controls['numeTipTaxa'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>
        <div class="form-field">
            <mat-form-field class="w-100" appearance="fill">
                <mat-label>Observații</mat-label>
                <input type="text" matInput formControlName="observatii" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['observatii'].valid && form.controls['observatii'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>
        <div class="action-btns">
            <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                {{ helper.dialogConfig.buttonLabels.close }}
            </button>
            <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                {{ helper.dialogConfig.buttonLabels.save }}
            </button>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>